import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

// CREATE PETTY CASH REQUEST
export const createPettyCashRequest = createAsyncThunk("createPettyCashRequest", async ({ data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`/petty-cash/request`, data);

		message.success("Petty cash request created successfully");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		message.error(err.response?.data?.message || "Failed to create petty cash request");
		return rejectWithValue(err.response.data);
	}
});

const PettyCashRequestSlice = createSlice({
	name: "PettyCashRequestSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetPettyCashRequestState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createPettyCashRequest.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createPettyCashRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createPettyCashRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashRequestState } = PettyCashRequestSlice.actions;
export default PettyCashRequestSlice.reducer;
